/* Sunrise Atelier — animated world flight map (self-contained, no dependencies)
   A dot-matrix world (visible continents) with planes flying OUT from Hong Kong
   to customer countries and IN from the factories to Hong Kong. */
(function () {
  'use strict';

  var CENTROID = {
    AD:[42.5,1.5], AT:[47.6,14.1], BE:[50.6,4.7], BG:[42.7,25.5], HR:[45.1,15.2],
    CY:[35.1,33.4], CZ:[49.8,15.5], DK:[56.0,10.0], EE:[58.7,25.0], FI:[64.0,26.0],
    FR:[46.6,2.4], DE:[51.2,10.4], GR:[39.1,22.0], HK:[22.32,114.17], HU:[47.2,19.5],
    IS:[64.9,-19.0], IE:[53.4,-8.0], IL:[31.5,34.8], IT:[42.8,12.6], LV:[56.9,24.6],
    LT:[55.2,23.9], LU:[49.8,6.1], MT:[35.9,14.4], MC:[43.7,7.4], NL:[52.2,5.3],
    NO:[61.0,8.5], PL:[51.9,19.1], PT:[39.5,-8.0], RO:[45.9,24.9], SG:[1.35,103.8],
    SK:[48.7,19.7], SI:[46.1,14.8], ES:[40.2,-3.7], SE:[62.0,15.0], CH:[46.8,8.2],
    TW:[23.7,121.0], AE:[24.0,54.0], GB:[54.0,-2.5], US:[39.8,-98.6]
  };
  var NAME = {
    AD:'Andorra',AT:'Austria',BE:'Belgium',BG:'Bulgaria',HR:'Croatia',CY:'Cyprus',
    CZ:'Czechia',DK:'Denmark',EE:'Estonia',FI:'Finland',FR:'France',DE:'Germany',
    GR:'Greece',HK:'Hong Kong',HU:'Hungary',IS:'Iceland',IE:'Ireland',IL:'Israel',
    IT:'Italy',LV:'Latvia',LT:'Lithuania',LU:'Luxembourg',MT:'Malta',MC:'Monaco',
    NL:'Netherlands',NO:'Norway',PL:'Poland',PT:'Portugal',RO:'Romania',SG:'Singapore',
    SK:'Slovakia',SI:'Slovenia',ES:'Spain',SE:'Sweden',CH:'Switzerland',TW:'Taiwan',
    AE:'United Arab Emirates',GB:'United Kingdom',US:'United States'
  };

  // Coarse land mask: per 5-degree latitude band (top lat), lists of [lngStart,lngEnd].
  var LAND = [
    [85,[[-45,-20]]],
    [80,[[-58,-20],[-105,-70],[55,110]]],
    [75,[[-130,-70],[-50,-22],[15,175]]],
    [70,[[-165,-140],[-135,-65],[-22,-14],[5,180]]],
    [65,[[-165,-140],[-135,-60],[-48,-40],[-10,180]]],
    [60,[[-140,-58],[-9,2],[4,180]]],
    [55,[[-130,-56],[-8,168]]],
    [50,[[-128,-66],[-6,150]]],
    [45,[[-126,-70],[-10,150]]],
    [40,[[-124,-74],[-9,60],[62,148]]],
    [35,[[-120,-78],[-8,60],[62,140]]],
    [30,[[-116,-80],[-10,58],[65,122]]],
    [25,[[-110,-82],[-16,58],[66,122]]],
    [20,[[-100,-84],[-17,55],[68,92],[95,123]]],
    [15,[[-92,-82],[-16,52],[72,90],[95,127]]],
    [10,[[-85,-60],[-13,48],[75,82],[95,127]]],
    [5,[[-80,-50],[-10,45],[95,150]]],
    [0,[[-80,-45],[8,42],[95,150]]],
    [-5,[[-78,-35],[10,42],[100,150]]],
    [-10,[[-78,-35],[12,42],[120,150]]],
    [-15,[[-72,-35],[13,42],[44,50],[113,150]]],
    [-20,[[-70,-40],[14,33],[43,49],[113,153]]],
    [-25,[[-72,-52],[16,33],[113,153]]],
    [-30,[[-73,-53],[17,30],[114,152]]],
    [-35,[[-74,-56],[18,28],[135,151],[166,179]]],
    [-40,[[-75,-62],[144,149],[166,179]]],
    [-45,[[-75,-65],[166,171]]],
    [-50,[[-75,-68]]]
  ];

  var W = 1000, LAT_TOP = 78, LAT_BOT = -56, STEP = 4;
  var H = Math.round(W * (LAT_TOP - LAT_BOT) / 360);
  function project(lat, lng) {
    return [ (lng + 180) / 360 * W, (LAT_TOP - lat) / (LAT_TOP - LAT_BOT) * H ];
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  function initOne(dataEl) {
    var cfg; try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var host = document.getElementById('flightmap-' + cfg.section);
    if (!host || host.dataset.rendered) return;
    host.dataset.rendered = '1';

    var accent = cfg.accent || '#B07C33';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'flightmap-svg', preserveAspectRatio: 'xMidYMid meet' });

    // Land dots
    var land = el('g', { class: 'fm-land' });
    LAND.forEach(function (band) {
      var latC = band[0] - 2.5;
      band[1].forEach(function (rng) {
        for (var lng = rng[0]; lng <= rng[1]; lng += STEP) {
          var p = project(latC, lng);
          land.appendChild(el('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: 1.7, fill: '#5a5346' }));
        }
      });
    });
    svg.appendChild(land);

    // Served-country nodes
    var served = cfg.served || [];
    var nodes = el('g', {});
    served.forEach(function (code) {
      var c = CENTROID[code]; if (!c) return;
      var p = project(c[0], c[1]);
      nodes.appendChild(el('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: 3, fill: accent, 'fill-opacity': '0.85', class: 'fm-node', 'data-code': code }));
    });
    svg.appendChild(nodes);

    // Hub markers
    var hubs = el('g', {});
    (cfg.hubs || []).forEach(function (hb) {
      var p = project(hb.lat, hb.lng);
      var col = hb.type === 'office' ? '#FFFFFF' : (hb.type === 'warehouse' ? '#C9C2B4' : accent);
      var r = hb.type === 'office' ? 5 : 4;
      hubs_ring(hubs, p, r, col);
    });
    function hubs_ring(g, p, r, col) {
      g.appendChild(el('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: r + 3, fill: 'none', stroke: col, 'stroke-opacity': '0.45', 'stroke-width': '1' }));
      g.appendChild(el('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: r, fill: col }));
    }
    svg.appendChild(hubs);

    var flightLayer = el('g', { class: 'fm-flights' });
    svg.appendChild(flightLayer);
    var labelG = el('g', { opacity: 0 });
    var labelText = el('text', { 'text-anchor': 'middle', fill: '#FFF6E6', 'font-size': '13', 'font-family': "'Cormorant Garamond', Georgia, serif", 'font-weight': '600' });
    labelG.appendChild(labelText); svg.appendChild(labelG);

    host.appendChild(svg);

    var HK = project(22.3193, 114.1694);

    function arcPath(a, b) {
      var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
      var dist = Math.hypot(b[0] - a[0], b[1] - a[1]);
      var lift = Math.min(120, dist * 0.28);
      return 'M' + a[0] + ',' + a[1] + ' Q' + mx + ',' + (my - lift) + ' ' + b[0] + ',' + b[1];
    }
    function highlight(code) {
      var n = nodes.querySelector('[data-code="' + code + '"]');
      if (n) { n.setAttribute('r', '5.5'); n.setAttribute('fill-opacity', '1'); }
    }

    // Build flight definitions
    var flights = [];
    // Outbound: HK -> customer destinations
    var dests = (cfg.destinations && cfg.destinations.length ? cfg.destinations : ['GB', 'US', 'AE', 'SG', 'FR']);
    dests.forEach(function (code, i) {
      var c = CENTROID[code]; if (!c) return;
      flights.push({ dir: 'out', from: HK, to: project(c[0], c[1]), code: code, color: '#FFF6E6', delay: i * 900 });
    });
    // Inbound: factories -> HK
    (cfg.hubs || []).filter(function (h) { return h.type === 'factory'; }).forEach(function (h, i) {
      flights.push({ dir: 'in', from: project(h.lat, h.lng), to: HK, code: null, color: accent, delay: 400 + i * 1100 });
    });

    // Create path + plane elements for each flight
    flights.forEach(function (f) {
      f.pathEl = el('path', { d: arcPath(f.from, f.to), fill: 'none',
        stroke: f.dir === 'out' ? 'rgba(240,217,168,0.55)' : 'rgba(176,124,51,0.5)',
        'stroke-width': f.dir === 'out' ? '1.4' : '1.2', 'stroke-linecap': 'round' });
      flightLayer.appendChild(f.pathEl);
      f.len = f.pathEl.getTotalLength();
      f.pathEl.setAttribute('stroke-dasharray', f.len);
      f.pathEl.setAttribute('stroke-dashoffset', f.len);
      var g = el('g', {});
      g.appendChild(el('circle', { r: 4, fill: f.color, 'fill-opacity': '0.22' }));
      g.appendChild(el('path', { d: 'M0,-5.5 L1.6,-0.8 L6,1.6 L1.6,2.4 L1.2,5.5 L0,4.3 L-1.2,5.5 L-1.6,2.4 L-6,1.6 L-1.6,-0.8 Z',
        fill: f.dir === 'out' ? '#FFF6E6' : '#F0D9A8', stroke: '#8A5F22', 'stroke-width': '0.5' }));
      f.planeEl = g; flightLayer.appendChild(g);
      f.t = 0; f.dur = Math.max(2600, f.len * 3.0); f.started = false; f.startAt = f.delay || 0;
      g.setAttribute('opacity', 0);
    });

    if (reduce) {
      flights.forEach(function (f) { f.pathEl.setAttribute('stroke-dashoffset', 0); });
      dests.forEach(highlight);
      return;
    }

    var t0 = null;
    function loop(ts) {
      if (t0 === null) t0 = ts;
      var elapsed = ts - t0;
      flights.forEach(function (f) {
        if (elapsed < f.startAt) return;
        if (!f.started) { f.started = true; f.local = elapsed; f.planeEl.setAttribute('opacity', 1); }
        var t = ((elapsed - f.local) % f.dur) / f.dur;
        var justLooped = t < f.prevT;
        f.prevT = t;
        var ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        var dist = f.len * ease;
        f.pathEl.setAttribute('stroke-dashoffset', f.len * (1 - ease));
        var pt = f.pathEl.getPointAtLength(dist);
        var pt2 = f.pathEl.getPointAtLength(Math.min(f.len, dist + 1));
        var ang = Math.atan2(pt2.y - pt.y, pt2.x - pt.x) * 180 / Math.PI + 90;
        f.planeEl.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ',' + pt.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
        if (justLooped && f.dir === 'out' && f.code) {
          highlight(f.code);
          labelText.textContent = NAME[f.code] || f.code;
          labelText.setAttribute('x', f.to[0]); labelText.setAttribute('y', f.to[1] - 12);
          labelG.setAttribute('opacity', 1);
          setTimeout(function () { labelG.setAttribute('opacity', 0); }, 1400);
        }
      });
      raf = requestAnimationFrame(loop);
    }
    var raf;
    function start() { if (!host.dataset.animating) { host.dataset.animating = '1'; raf = requestAnimationFrame(loop); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { start(); io.disconnect(); } }); }, { rootMargin: '120px' });
      io.observe(host);
    } else { start(); }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('script[id^="flightmap-data-"]'), initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
